<template>
  <div class="photo-detail">
    <!-- 顶部导航 -->
    <header class="header">
      <button class="back-btn" @click="goBack">← 返回主页</button>
      <h2>约拍详情</h2>
    </header>

    <!-- Banner -->
    <section class="banner">
      <h1>同城定制约拍</h1>
      <p>汉服 | 古风 | 电影感 | 个人写真 | 创作拍摄 | 一对一服务</p>
    </section>

    <!-- 服务亮点 -->
    <section class="adv">
      <div class="item">一对一拍摄</div>
      <div class="item">风格定制</div>
      <div class="item">精修质感</div>
      <div class="item">服装可租</div>
    </section>

    <!-- 可拍摄风格（增加图片） -->
    <section class="styles">
      <h2>可拍摄风格</h2>
      <div class="grid">
        <div class="card">
          <img src="/clothes/hanfu2.jpg" alt="古风汉服" />
          <p>古风汉服</p>
        </div>
        <div class="card">
          <img src="/clothes/hefu.jpg" alt="日系电影感" />
          <p>日系电影感</p>
        </div>
        <div class="card">
          <img src="/clothes/lolita.jpg" alt="华丽欧式风格" />
          <p>甜美系风格</p>
        </div>
        <div class="card">
          <img src="/clothes/cos.jpg" alt="cosplay" />
          <p>cosplay</p>
        </div>
        <div class="card">
          <img src="/clothes/changfu.jpg" alt="定制创作" />
          <p>定制创作</p>
        </div>
      </div>
    </section>

    <!-- 约拍套餐（公开价格） -->
    <section class="packages">
      <h2>约拍套餐</h2>
      <div class="grid">
        <div class="card">
          <h3>单人套餐</h3>
          <p>拍摄时长：1.5~2小时</p>
          <p>底片：60~100张</p>
          <p>精修：6张</p>
          <p class="price">239 元</p>
        </div>
        <div class="card">
          <h3>双人套餐</h3>
          <p>拍摄时长：2.5~3小时</p>
          <p>底片：150~200张</p>
          <p>精修：12张</p>
          <p class="price">349 元</p>
        </div>
        <div class="card">
          <h3>单人精致套餐</h3>
          <p>服务时长：4小时+</p>
          <p>底片全送</p>
          <p>精修：20张</p>
          <p>赠送花絮视频</p>
          <p>服装+妆造指导</p>
          <p>包妆发 + 600内档位服装一套</p>
          <p class="price">699 元</p>
        </div>
        <div class="card">
          <h3>3人以上团片套餐</h3>
          <p>服务时长：按时间</p>
          <p>底片全送</p>
          <p>精修：15张</p>
          <p class="price">150/人 元</p>
        </div>
        <div class="card">
          <h3>专人定制套餐</h3>
          <p>服务时长：按需</p>
          <p>底片全送</p>
          <p>精修：按需</p>
          <p>电影感视频/花絮视频</p>
          <p>服装+妆造指导</p>
          <p>包全部妆造</p>
          <p>道具现买</p>
          <p class="price">根据具体情况确定</p>
        </div>
      </div>
    </section>

    <!-- 拍摄流程 -->
    <section class="flow">
      <h2>拍摄流程</h2>
      <div class="steps">
        <div>咨询沟通</div>
        <div>支付定金</div>
        <div>确认风格</div>
        <div>现场拍摄</div>
        <div>选片精修</div>
        <div>支付尾款</div>
        <div>交付成品</div>
      </div>

      <div class="notice-small">
        <div class="notice-title" @click="toggleNotes">
          {{ isNotesOpen ? '收起' : '注意事项（重要）' }}
          <span>{{ isNotesOpen ? '▲' : '▼' }}</span>
        </div>
        <div class="notes-content" v-show="isNotesOpen">
          <ul>
            <li>定金金额为套餐总价的20%，支付后确认拍摄档期</li>
            <li>定金一经支付，非商家原因不予退还</li>
            <li>若因客户原因取消拍摄，定金不予退还；可改期一次（需提前3天告知）</li>
            <li>拍摄当天需支付尾款后开始拍摄</li>
            <li>精修照片交付周期为7-15个工作日</li>
            <li>客户需配合拍摄时间，迟到超过30分钟视为改期，需提前沟通</li>
            <li>外景拍摄产生的场地费、交通费由客户承担</li>
            <li>最终成片版权归摄影师所有，客户拥有使用权（非商用）</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- 注意事项（点击展开） -->
<!--    <section class="notes">-->
<!--      <h2>注意事项</h2>-->
<!--      <div class="expand-btn" @click="toggleNotes">-->
<!--        {{ isNotesOpen ? '收起详情' : '查看详情' }}-->
<!--        <span class="arrow">{{ isNotesOpen ? '↑' : '↓' }}</span>-->
<!--      </div>-->
<!--      <div class="notes-content" v-show="isNotesOpen">-->
<!--        <ul>-->
<!--          <li>定金金额为套餐总价的20%，支付后确认拍摄档期</li>-->
<!--          <li>定金一经支付，非商家原因不予退还</li>-->
<!--          <li>若因客户原因取消拍摄，定金不予退还；可改期一次（需提前3天告知）</li>-->
<!--          <li>拍摄当天需支付尾款后开始拍摄</li>-->
<!--          <li>精修照片交付周期为7-15个工作日</li>-->
<!--          <li>客户需配合拍摄时间，迟到超过30分钟视为改期，需提前沟通</li>-->
<!--          <li>外景拍摄产生的场地费、交通费由客户承担</li>-->
<!--          <li>最终成片版权归摄影师所有，客户拥有使用权（非商用）</li>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </section>-->


    <!-- 服装实拍展示（4套） -->
    <section class="clothes">
      <h2>可租赁服装(多为lolita服饰)</h2>
      <div class="grid">
        <div class="card">
          <img src="/clothes/wuxia.jpg" alt="武侠" />
          <p>武侠</p>
        </div>
        <div class="card">
          <img src="/clothes/hanfuclo.jpg" alt="青玉金铃" />
          <p>汉服</p>
        </div>
        <div class="card">
          <img src="/clothes/tusp.jpg" alt="蝴蝶结小兔sp" />
          <p>Lolita</p>
        </div>
        <div class="card">
          <img src="/showphotos/5.jpg" alt="草莓蛋糕公主" />
          <p>Lolita</p>
        </div>
      </div>
    </section>




    <!-- 客户好评（3条） -->
<!--    <section class="reviews">-->
<!--      <h2>客户好评</h2>-->
<!--      <div class="list">-->
<!--        <div class="item">-->
<!--          <p class="text">摄影师特别有耐心，拍出来的效果超出预期，太喜欢了！</p>-->
<!--          <p class="name">—— 小桃</p>-->
<!--        </div>-->
<!--        <div class="item">-->
<!--          <p class="text">汉服造型绝美，修图质感高级，强烈推荐！</p>-->
<!--          <p class="name">—— 林同学</p>-->
<!--        </div>-->
<!--        <div class="item">-->
<!--          <p class="text">拍摄氛围轻松，出片超快，服务超棒，下次还来！</p>-->
<!--          <p class="name">—— 阿婉</p>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->

    <!-- 预约表单 -->
<!--    <section class="contact">-->
<!--      <h2>预约咨询</h2>-->
<!--      <form action="https://formspree.io/f/xxxx" method="POST">-->
<!--        <input type="text" name="name" placeholder="姓名" required />-->
<!--        <input type="text" name="wechat" placeholder="微信" required />-->
<!--        <select name="style">-->
<!--          <option>古风汉服</option>-->
<!--          <option>武侠电影感</option>-->
<!--          <option>清新人像</option>-->
<!--          <option>定制创作</option>-->
<!--        </select>-->
<!--        <input type="text" name="date" placeholder="期望拍摄日期" />-->
<!--        <button type="submit">提交预约</button>-->
<!--      </form>-->
<!--    </section>-->


    <!-- 预约咨询（电脑手机都能用 · 无第三方） -->
    <section class="contact">
      <h2>预约咨询</h2>
      <div class="form-box">
        <form @submit.prevent="submitForm">
          <input v-model="form.name" type="text" placeholder="备注名" />
<!--          <input v-model="form.wechat" type="text" placeholder="微信/电话号码" required />-->
<!--          <select v-model="form.style" required>-->
<!--            <option value="">请选择拍摄风格</option>-->
<!--            <option>古风汉服</option>-->
<!--            <option>武侠电影感</option>-->
<!--            <option>清新人像</option>-->
<!--            <option>定制创作</option>-->
<!--          </select>-->
          <select v-model="form.style">
            <option value="">请选择套餐</option>
            <option>单人</option>
            <option>双人</option>
            <option>团片</option>
            <option>定制创作</option>
          </select>
          <input v-model="form.date" type="date" placeholder="期望拍摄日期" required />
          <button type="submit" class="submit-btn">提交预约</button>
        </form>

        <!-- 提交后显示复制内容 -->
        <div class="success" v-show="showSuccess">
          <p>✅ 预约信息已生成</p>
          <p>点击下方按钮复制，发给我即可</p>
          <button @click="copyInfo" class="copy-btn">复制预约信息</button>
                <div class="qrcode-box">
                  <img src="/code.png" alt="微信二维码" />

                </div>
        </div>
      </div>
    </section>

<!--    <section class="wechat-qrcode">-->
<!--      <h2>扫码添加微信咨询</h2>-->
<!--      <div class="qrcode-box">-->
<!--        <img src="/code.png" alt="微信二维码" />-->
<!--        <button class="contact-btn" @click="goWechat">-->
<!--          点击添加微信 · 预约拍摄-->
<!--        </button>-->
<!--&lt;!&ndash;        <p >微信号：yeyu20001105</p>&ndash;&gt;-->
<!--      </div>-->
<!--    </section>-->

    <footer>
      <p>© 2025 个人摄影服务 | 微信：yeyu20001105</p>
    </footer>
  </div>
</template>

<script setup>
import {reactive, ref} from 'vue'

const goBack = () => {
  window.history.back()
}

// 控制注意事项展开/收起
const isNotesOpen = ref(false)
const toggleNotes = () => {
  isNotesOpen.value = !isNotesOpen.value
}
//
// const goWechat = () => {
//   // 直接跳微信聊天（国内最稳）
//   window.location.href = "weixin://contacts/profile/yeyu20001105"
// }

// 表单数据
const form = reactive({
  name: '',
  wechat: '',
  style: '',
  date: ''
})

const showSuccess = ref(false)
const infoText = ref('')

// 提交生成信息
const submitForm = () => {
  infoText.value = `
约拍预约
备注名：${form.name}
套餐：${form.style}
日期：${form.date}
  `.trim()
  showSuccess.value = true
}

// 复制信息
const copyInfo = () => {
  navigator.clipboard.writeText(infoText.value)
  alert('已复制！请打开微信粘贴给我～')
}

</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}
.header {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px 6vw;
  background: #fff;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  z-index: 99;
}
.back-btn {
  padding: 8px 14px;
  background: #222;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
.banner {
  height: 60vh;
  background: linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.7)),
  url("/src/assets/hefu.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-align: center;
  padding: 0 6vw;
}
.banner h1 { font-size: 36px; margin-bottom: 12px; }
.banner p { font-size: 16px; opacity: 0.9; }

.adv {
  padding: 40px 6vw;
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
  background: #fafafa;
}
.adv .item {
  padding: 12px 20px;
  background: #fff;
  border-radius: 50px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.styles, .clothes, .packages, .flow, .notes, .reviews, .contact, .wechat-qrcode {
  background-color: #f5f2ee ;
  padding: 60px 6vw;
}

.packages .card {
  transition: all 0.3s ease;
  border: 2px solid transparent;
}
.packages .card:hover {
  border-color: #e63946;
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.notice-small {
  max-width: 700px;
  margin: 30px auto 0;
  text-align: center;
  font-size: 14px;
  color: #555;
}
.notice-title {
  color: #000;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  /* 下面这行是新加的 */
  transition: color 0.3s;
}
/* 鼠标悬停变蓝 */
.notice-title:hover {
  color: #007bff;
}
.notice-content {
  margin-top: 12px;
  margin-left: 5px;
  text-align: left;
  background: #f6f6f6;
  padding: 16px 20px;
  border-radius: 10px;
  line-height: 1.6;
}
.notice-content p {
  margin: 6px 0;
}

h2 {
  font-size: 26px;
  text-align: center;
  margin-bottom: 30px;
}

header h2 {
  margin: 0;
}
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 26px;
}

/* 可拍摄风格样式（增加图片） */
.styles .card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  overflow: hidden;
}
.styles .card img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  margin-bottom: 16px;
}
.styles .card p {
  padding: 0 10px 20px;
  font-size: 16px;
  font-weight: 500;
}

.clothes img {
  width: 100%;
  height: 360px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: 10px;
}
.clothes .card {
  text-align: center;
}

.packages .card {
  background: #fff;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 4px 14px rgba(0,0,0,0.05);
}
.packages .hot { border: 2px solid #e63946; }
.packages h3 { margin-bottom: 14px; }
.packages p { color: #666; margin-bottom: 6px; }
.price {
  color: #e63946;
  font-weight: bold;
  font-size: 18px;
  margin-top: 10px;
}

.steps {
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}
.steps div {
  padding: 10px 16px;
  background: #ffffff;
  border-radius: 8px;
}

/* 注意事项样式 */
.notes {
  background: #f8f8f8;
}
.expand-btn {
  width: 200px;
  margin: 0 auto;
  padding: 12px 20px;
  background: #222;
  color: #fff;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.notes-content {
  max-width: 800px;
  margin: 20px auto 0;
  padding: 24px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}
.notes-content ul {
  list-style: disc;
  padding-left: 20px;
  line-height: 1.8;
  color: #333;
}
.notes-content li {
  margin-bottom: 8px;
}

.reviews { background: #fafafa; }
.list {
  max-width: 700px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.item {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.text { margin-bottom: 8px; }
.name { color: #666; text-align: right; }

form {
  max-width: 550px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
input, select {
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 15px;
}
form button {
  padding: 17px;
  background: #111;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
}

/* 微信二维码样式 */
.wechat-qrcode {
  background: #fafafa;
  text-align: center;
}
.qrcode-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.qrcode-box img {
  width: 200px;
  height: 200px;
  border: 8px solid #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}
.qrcode-box p {
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

footer {
  background: #111;
  color: #eee;
  text-align: center;
  padding: 30px 0;
  font-size: 14px;
}

.form-box {
  max-width: 500px;
  margin: 0 auto;
  background: #fff;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}
form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
form input, form select {
  padding: 14px;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 15px;
}
.submit-btn {
  padding: 15px;
  background: #111;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
}
.success {
  text-align: center;
  margin-top: 20px;
  line-height: 1.7;
}
.copy-btn {
  padding: 12px 24px;
  background: #07c160;
  color: #fff;
  border: none;
  border-radius: 10px;
  margin: 10px 0;
  cursor: pointer;
}
.wechat {
  margin-top: 10px;
  font-weight: bold;
  color: #333;
}
</style>
